import React from "react";
import { AgendaCard } from "./AgendaCard";

const today = () => new Date().toLocaleDateString("sv-SE");
const dayLabel = (iso, opts) => new Date(`${iso}T12:00:00`).toLocaleDateString("it-IT", opts);
const byDay = (items, d) => items.filter((i) => i.data === d);

const DayHeader = ({ d, count, inline }) => {
  const isToday = d === today();
  return (
    <div className={`flex items-center gap-2 ${inline ? "" : "flex-col !items-start gap-0"}`} data-testid={`agenda-day-${d}`}>
      <div className="text-[11px] font-bold uppercase tracking-wider" style={{ color: isToday ? "#FB8C00" : "var(--text-muted)" }}>
        {dayLabel(d, { weekday: "long" })}{isToday && " · Oggi"}
      </div>
      <div className="text-lg font-extrabold" style={{ fontFamily: "Manrope" }}>{dayLabel(d, { day: "numeric", month: "short" })}</div>
      <span className="text-[11px] ml-auto" style={{ color: "var(--text-muted)" }}>{count ? `${count} lavor${count === 1 ? "o" : "i"}` : ""}</span>
    </div>
  );
};

export const AgendaWeekGrid = ({ days, items, cardProps = {} }) => (
  <div className="overflow-x-auto pb-2" data-testid="agenda-week-grid">
    <div className="grid grid-cols-7 gap-3 min-w-[1100px]">
      {days.map((d) => {
        const list = byDay(items, d);
        return (
          <div key={d} className="rounded-xl p-2.5 space-y-2 min-h-[220px]"
            style={{ background: d === today() ? "#FFF8E1" : "var(--surface-muted)", border: "1px solid var(--border)" }}>
            <DayHeader d={d} count={list.length} />
            {list.length === 0 && <div className="text-xs py-6 text-center" style={{ color: "var(--text-muted)" }}>Libero</div>}
            {list.map((it) => <AgendaCard key={`${it.tipo}-${it.id}`} item={it} compact {...cardProps} />)}
          </div>
        );
      })}
    </div>
  </div>
);

export const AgendaDayList = ({ days, items, cardProps = {} }) => (
  <div className="space-y-5" data-testid="agenda-day-list">
    {days.map((d) => {
      const list = byDay(items, d);
      return (
        <section key={d} className="space-y-2">
          <div className="border-b pb-1.5" style={{ borderColor: "var(--border)" }}><DayHeader d={d} count={list.length} inline /></div>
          {list.length === 0
            ? <div className="text-xs" style={{ color: "var(--text-muted)" }}>Nessun lavoro in programma</div>
            : <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">{list.map((it) => <AgendaCard key={`${it.tipo}-${it.id}`} item={it} {...cardProps} />)}</div>}
        </section>
      );
    })}
  </div>
);
